"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Errors = {
    TASK_IS_UNDEFINED: "Environment variable TASK must be defined.",
    TASK_NOT_FOUND: "TASK has not been found.",
    PROVIDER_IS_UNDEFINED: "Environment variable IPC_PROVIDER or JSONRPC_PROVIDER must be defined.",
    PROVIDER_NOT_FOUND: "IPC_PROVIDER or JSONRPC_PROVIDER has not been found.",
    ASSET_TYPE_NOT_FOUND: "Asset type not found. Provide asset type 1 | 2 | 3 ",
    DB_ERROR_PROVIDING_AGREEMENT: "Error inserting agreement data to the database, ",
    notFound: "deployment not found",
    chainIdNotFound: "provided chainId has not been found!",
    notFoundInTheDb: "not found in the db",
    deploymentFailed: "deployment failed"
};
exports.Errors = Errors;
